import script from "./IDESideBarContentResizer.vue?vue&type=script&lang=ts&setup=true"
export * from "./IDESideBarContentResizer.vue?vue&type=script&lang=ts&setup=true"

import "./IDESideBarContentResizer.vue?vue&type=style&index=0&id=55b1429e&scoped=true&lang=less"

import exportComponent from "/home/gibo/development/primakurzyonline.cz-screencast/trunk/lector-code/pko-lector-code-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55b1429e"]])

export default __exports__